import { memo, ReactElement } from 'react';
import { useLocation } from 'react-router-dom';

import Breadcrumbs from '~/ui/components/common/Breadcrumbs';

import { useStoreState } from '~/store/hooks';
import useRole from '~/store/user/hooks/useRole';
import { NETWORK } from '~/ui/constants/paths';

import styles from './AllocationBreadcrumbs.module.scss';

const AllocationBreadcrumbs = (): ReactElement => {
  const { pathname } = useLocation();
  const actTeam = useStoreState(state => state.actTeam.current);

  const { clinic: userClinic } = useStoreState(state => state.user.current);

  const { isActTeam } = useRole();

  const breadcrumbItems = [
    ...(isActTeam
      ? [
          {
            title: actTeam?.name,
            to: {
              pathname: NETWORK,
            },
          },
        ]
      : [{ to: NETWORK, title: `${userClinic.name} Teams` }]),
    { to: pathname, title: 'Add Client Allocation' },
  ];

  return (
    <>
      <h2 className={styles.title}>Add Client Allocation</h2>
      <Breadcrumbs itemsForBreadcrumbs={breadcrumbItems} />
    </>
  );
};

export default memo(AllocationBreadcrumbs);
